/**
 * Tabla AG Grid para el listado de reubicaciones (wrapper del componente compartido).
 */
import { ColDef } from 'ag-grid-community';
import React, { useCallback, useRef } from 'react';
import { AgGridTable, AgGridTableRef } from '@shared/components/ui/AgGridTable';
import { RelocationModel } from '../../models/Relocation';

interface RelocationsAgGridTableProps {
  relocations: RelocationModel[];
  isLoading?: boolean;
  isFetching?: boolean;
  className?: string;
  refetch?: () => void;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  sorting?: { field: string; direction: 'asc' | 'desc' } | null;
  onSortingChange?: (sorting: { field: string; direction: 'asc' | 'desc' } | null) => void;
  columnDefs?: ColDef[];
}

export const RelocationsAgGridTable = React.memo(function RelocationsAgGridTable({
  relocations,
  isFetching = false,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  sorting,
  onSortingChange,
  columnDefs,
}: RelocationsAgGridTableProps) {
  const agGridRef = useRef<AgGridTableRef>(null);
  const handleGridReady = useCallback(() => {}, []);
  const columnDefsWithRenderers: ColDef[] = columnDefs || [];

  return (
    <div className={`w-full ${isFetching && !isFetchingNextPage ? 'opacity-50 pointer-events-none' : ''}`}>
      <AgGridTable
        ref={agGridRef}
        data={relocations}
        columnDefs={columnDefsWithRenderers}
        height="calc(100vh - 150px)"
        enableSelection={false}
        onGridReady={handleGridReady}
        className="rounded-lg shadow-sm"
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        gridOptions={{}}
        sorting={sorting}
        onSortingChange={onSortingChange}
      />
    </div>
  );
});
